import { MouseEvent, ReactNode } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import styles from './icon-button.module.scss';
import { IconButtonShape } from './icon-button.types';

interface IconButtonProps {
  /** Required: these buttons have no text, so this is their only accessible name. */
  label: string;
  children: ReactNode;
  shape?: IconButtonShape;
  /** Receives the event so a button nested in a clickable row can stop propagation. */
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  /** Swaps the icon for a spinner and blocks the click while a request is in flight. */
  loading?: boolean;
  className?: string;
}

export default function IconButton({
  label,
  children,
  shape = 'square',
  onClick,
  disabled,
  loading,
  className,
}: IconButtonProps) {
  return (
    <button
      aria-label={label}
      aria-busy={loading}
      className={clsx(styles.button, styles[`button-${shape}`], className)}
      onClick={onClick}
      disabled={disabled || loading}
      type="button"
    >
      {loading ? <LoadingOutlined spin /> : children}
    </button>
  );
}
